import { type PageKey } from "@/lib/site";
import { zhLegalContent } from "./legal-zh";

export const zhContent = {
  metadata: {
    home: {
      title: "虎鲸国际物流 OrcaParcel｜国际集运与包裹转运服务平台",
      description:
        "虎鲸国际物流 OrcaParcel 专注国际集运、包裹转运、仓储中转与全球派送，为海外华人、留学生及跨境用户提供包裹预报、拆箱合包、运费估算和多渠道发货服务。"
    },
    serviceIntro: {
      title: "服务介绍｜国际集运、包裹转运、拆箱合包｜OrcaParcel",
      description: "了解 OrcaParcel 的国际集运、包裹转运、拆箱合包、仓储代收与增值服务。"
    },
    guarantee: {
      title: "服务保障｜包裹保障、价格透明、延误处理｜OrcaParcel",
      description: "查看虎鲸国际物流在隐私保护、价格透明、包裹保障、延误处理和异常协助方面的服务说明。"
    },
    warehouse: {
      title: "仓库地址｜华南仓收件信息与会员标识说明｜OrcaParcel",
      description: "获取 OrcaParcel 华南仓收件人、电话、详细地址、邮编和会员标识填写说明。"
    },
    process: {
      title: "集运流程｜4 步完成国际集运转运｜OrcaParcel",
      description: "4 步了解虎鲸国际物流从注册、购物填仓库地址、包裹预报合箱到支付发货的完整流程。"
    },
    calculator: {
      title: "运费估算｜国际集运参考运费查询｜OrcaParcel",
      description: "输入目的地、渠道、重量和体积，获取 OrcaParcel 国际集运参考运费、计费重量和费用构成。"
    },
    prealert: {
      title: "包裹预报｜提交国内快递单号与包裹信息｜OrcaParcel",
      description: "提交国内快递单号、商品信息和增值服务需求，帮助仓库识别并处理包裹。"
    },
    tracking: {
      title: "包裹追踪｜查询包裹入库、打包与运输状态｜OrcaParcel",
      description: "支持国内快递单号、平台包裹号和国际运单号查询，展示包裹入库、合包、发货和运输状态。"
    },
    routes: {
      title: "路线查询｜空运、海运、经济线与特快线｜OrcaParcel",
      description: "按区域和货物类型查询北美、欧洲、澳新、亚洲及港澳台线路，查看参考时效和适合货物类型。"
    },
    help: {
      title: "帮助中心｜国际集运常见问题与新手指南｜OrcaParcel",
      description: "查找国际集运、仓库地址、包裹预报、运费估算、拆箱合包、禁运品和服务保障相关问题。"
    },
    guide: {
      title: "新手指南｜首次使用国际集运转运流程｜OrcaParcel",
      description: "了解虎鲸国际物流新手使用流程，包括注册会员、填写仓库地址、提交包裹预报、选择运输渠道、支付发货和物流追踪。"
    },
    faq: {
      title: "常见问题｜国际集运转运 FAQ｜OrcaParcel",
      description: "按账号、仓库地址、包裹预报、运费估算、线路、禁运品和服务保障等类型查看国际集运常见问题。"
    },
    news: {
      title: "新闻动态｜平台公告、线路动态与集运百科｜OrcaParcel",
      description: "查看虎鲸国际物流平台公告、线路调整、服务升级、集运百科、新手教程、禁运提醒和假期安排。"
    },
    careers: {
      title: "加入我们｜OrcaParcel Careers｜虎鲸国际物流",
      description: "了解虎鲸国际物流招聘方向、工作方式、开放职位和简历投递方式。"
    },
    contact: {
      title: "联系我们｜微信、WhatsApp、Telegram、QQ 客服｜OrcaParcel",
      description: "通过 QQ、微信、WhatsApp、Telegram、Line、电话、微信公众号和邮箱联系 OrcaParcel 客服。"
    },
    about: {
      title: "公司简介｜关于虎鲸国际物流 OrcaParcel",
      description: "了解虎鲸国际物流 OrcaParcel 的国际集运、包裹转运、仓储代收、拆箱合包、多渠道发货和跨境寄送服务能力。"
    },
    register: {
      title: "注册｜获取专属仓库地址和会员标识｜OrcaParcel",
      description: "注册 OrcaParcel 账号，获取专属仓库地址和会员标识，开始包裹预报和国际集运。"
    },
    login: {
      title: "登录｜虎鲸国际物流 OrcaParcel",
      description: "登录虎鲸国际物流 OrcaParcel，管理包裹预报、运费估算、包裹追踪和发货流程。"
    },
    legalServiceAgreement: {
      title: "虎鲸国际物流 服务协议",
      description: "了解 OrcaParcel 服务协议，包括账户注册、仓库地址使用、包裹预报、仓储代收、拆箱合包、国际运输、费用支付及异常处理规则。"
    },
    legalPrivacyPolicy: {
      title: "虎鲸国际物流 隐私政策",
      description: "了解 OrcaParcel 隐私政策，包括国际集运、包裹转运、仓储代收、物流追踪和客服服务中的信息收集、使用、存储与保护。"
    },
    legalRestrictedItems: {
      title: "禁运品与限制寄送物品须知｜虎鲸国际物流 OrcaParcel",
      description: "了解国际集运禁运品、限制寄送物品和敏感货规则，发货前请按目的地、线路规则和承运方要求确认。"
    },
    legalServiceGuarantee: {
      title: "虎鲸国际物流 服务保障条款",
      description: "了解 OrcaParcel 服务保障条款，包括仓储代收、包裹处理、拆箱合包、国际运输、物流追踪和异常处理说明。"
    }
  } satisfies Record<PageKey, { title: string; description: string }>,
  chrome: {
    brandAria: "OrcaParcel 首页",
    logoAlt: "虎鲸国际物流 OrcaParcel",
    navAria: "主导航",
    mobileNavAria: "移动端导航",
    language: {
      current: "简体中文",
      zh: "简体中文",
      en: "English",
      mobileSwitchToZh: "中文",
      mobileSwitchToEn: "English",
      aria: "语言切换"
    },
    actions: {
      login: "登录",
      register: "注册",
      openMenu: "打开菜单",
      closeMenu: "关闭菜单"
    },
    nav: [
      { label: "首页", path: "" },
      {
        label: "集运服务",
        children: [
          { label: "服务介绍", path: "services/introduction" },
          { label: "服务保障", path: "services/guarantee" },
          { label: "仓库地址", path: "warehouse" }
        ]
      },
      { label: "集运流程", path: "process" },
      {
        label: "集运工具",
        children: [
          { label: "运费估算", path: "tools/shipping-calculator" },
          { label: "包裹预报", path: "tools/parcel-prealert" },
          { label: "包裹追踪", path: "tools/tracking" },
          { label: "路线查询", path: "tools/routes" }
        ]
      },
      { label: "帮助中心", path: "help" },
      { label: "联系我们", path: "contact" }
    ],
    footer: {
      brandAria: "OrcaParcel 虎鲸国际物流首页",
      brandCopy: "虎鲸国际物流 OrcaParcel 专注国际集运、包裹转运、仓储中转与全球派送，为海外华人、留学生及跨境商家提供清晰的一站式集运转运服务。",
      serviceTagsAria: "服务标签",
      serviceTags: ["集运", "转运", "合包", "仓储"],
      columns: [
        {
          title: "集运服务",
          items: [
            ["服务介绍", "services/introduction"],
            ["服务保障", "services/guarantee"],
            ["仓库地址", "warehouse"],
            ["集运流程", "process"]
          ]
        },
        {
          title: "集运工具",
          items: [
            ["运费估算", "tools/shipping-calculator"],
            ["包裹预报", "tools/parcel-prealert"],
            ["包裹追踪", "tools/tracking"],
            ["路线查询", "tools/routes"]
          ]
        },
        {
          title: "帮助支持",
          items: [
            ["帮助中心", "help"],
            ["新手指南", "guide"],
            ["常见问题", "faq"],
            ["禁运品说明", "legal/restricted-items"]
          ]
        },
        {
          title: "关于我们",
          items: [
            ["公司简介", "about"],
            ["联系我们", "contact"],
            ["新闻动态", "news"],
            ["加入我们", "careers"]
          ]
        }
      ],
      copyright: "© 2026 OrcaParcel 虎鲸国际物流. All rights reserved.",
      legalLinks: [
        ["服务协议", "legal/service-agreement"],
        ["隐私政策", "legal/privacy-policy"],
        ["禁运品须知", "legal/restricted-items"],
        ["服务保障条款", "legal/service-guarantee"]
      ],
      filingPlaceholder: "备案信息待补充"
    },
    floatingContact: {
      aria: "快捷客服",
      wechat: "微信",
      qrText: "微信扫一扫添加",
      qq: "QQ 客服",
      online: "在线咨询",
      backTop: "返回顶部"
    },
    mobileContact: {
      aria: "移动端快捷联系",
      primary: ["微信", "WhatsApp", "电话"],
      more: "更多客服",
      close: "关闭",
      sheet: ["QQ", "Telegram", "Line", "邮箱", "微信公众号"]
    }
  },
  root: {
    logoAlt: "虎鲸国际物流 OrcaParcel",
    title: "虎鲸国际物流 OrcaParcel",
    copy: "请选择语言进入官网。英文内容待人工翻译提供，当前英文路由保留同结构内容。",
    zhButton: "进入中文官网",
    enButton: "English Preview"
  },
  pending: {
    labels: {
      home: "首页",
      serviceIntro: "服务介绍",
      guarantee: "服务保障",
      warehouse: "仓库地址",
      process: "集运流程",
      calculator: "运费估算",
      prealert: "包裹预报",
      tracking: "包裹追踪",
      routes: "路线查询",
      help: "帮助中心",
      contact: "联系我们",
      about: "公司简介",
      guide: "新手指南",
      faq: "常见问题",
      news: "新闻动态",
      careers: "加入我们",
      register: "注册",
      login: "登录",
      legalServiceAgreement: "服务协议",
      legalPrivacyPolicy: "隐私政策",
      legalRestrictedItems: "禁运品须知",
      legalServiceGuarantee: "服务保障条款"
    },
    zhCopy: "该页面下一步将按对应 Stitch 目录的 code.html 与 screen.png 逐块组件化迁移。当前占位仅用于保留路由和 SEO 结构，不作为最终视觉。",
    enTitle: "English Version Coming Soon",
    enCopy: "The English website is being prepared. Please use the Chinese website for current service information, or contact support for assistance."
  },
  pages: {
    home: {
      hero: {
        kicker: "全球包裹集运专家",
        titleLines: ["国际集运更省心", "包裹转运更高效"],
        subtitle: "虎鲸国际物流 OrcaParcel 专注国际集运、包裹转运、仓储中转与全球派送，为海外华人、留学生及跨境商家提供透明、高效、稳定的一站式集运转运服务。",
        badges: ["上门取件", "拍照验货", "可视化打包", "闪电发货"],
        primaryCta: "立即开始集运",
        secondaryCta: "查询运费报价",
        imageAlt: "OrcaParcel 国际集运线路视觉"
      },
      quickTools: {
        title: "包裹查询",
        placeholder: "输入国内快递/国际单号",
        searchAria: "查询包裹",
        entries: [
          ["calculate", "运费估算", "tools/shipping-calculator"],
          ["warehouse", "仓库地址", "warehouse"],
          ["notification_add", "包裹预报", "tools/parcel-prealert"],
          ["map", "线路查询", "tools/routes"]
        ]
      },
      core: {
        title: "一站式国际集运转运服务",
        copy: "从国内包裹代收到拆箱合包、仓储中转与全球发运，虎鲸国际物流为跨境用户提供清晰、高效、稳定的集运解决方案。",
        services: [
          ["all_inbox", "国际集运", "支持多个国内包裹集中入库、统一管理、合并发往海外，适合海外华人、留学生及跨境购物用户。"],
          ["flight_takeoff", "包裹转运", "提供中国大陆发往英国、美国、加拿大、澳洲、新加坡等地区的跨境转运服务。"],
          ["deployed_code", "拆箱合包", "按需拆箱、去除多余包装、合理合包，帮助用户合理节省运费。"],
          ["inventory_2", "仓储代收", "华南仓提供包裹代收、入库拍照与统一发货服务，注册会员可享受阶段性仓储服务。"]
        ]
      },
      valueServices: {
        title: "增值服务，让跨境寄送更省心",
        copy: "针对不同寄送场景，提供可选的贴心服务。",
        linkLabel: "查看更多服务",
        services: [
          ["shopping_cart", "代购代付", "协助采购与支付，解决结算难题"],
          ["photo_camera", "拍照验货", "按需拍摄入库件，质量可视化"],
          ["visibility", "打包可视化", "记录拆箱合包过程，处理更透明"],
          ["home_pin", "上门取件", "国内便捷揽收，足不出户寄全球"],
          ["split_scene", "多渠道发货", "空海运灵活搭配，按需选择时效"]
        ]
      },
      process: {
        title: "4 步完成国际集运，流程清晰更省心",
        copy: "简化的标准流程，让跨境运输管理更清晰。",
        steps: [
          ["person_add", "注册会员获取地址", "注册即获专属收货地址及会员标识，用于电商平台下单。"],
          ["shopping_basket", "线上购物填入地址", "在淘宝、京东等平台购物，收件地址填写虎鲸华南仓。"],
          ["inventory", "包裹预报及合箱", "包裹到库后申请合发，我们会按需拆箱合包减少体积运费。"],
          ["payments", "支付运费等待签收", "在线称重并支付运费，按物流节点查询包裹状态。"]
        ]
      },
      estimate: {
        title: "运费预估",
        destinationLabel: "目的地",
        destinationOptions: ["英国 (UK)", "美国 (USA)", "加拿大 (Canada)", "澳洲 (Australia)"],
        channelLabel: "渠道类型",
        channelOptions: ["国际特快线", "经济海运线", "敏感货专线"],
        fields: [
          ["重量 (kg)", "0.0"],
          ["长度 (cm)", "0"],
          ["宽度 (cm)", "0"]
        ],
        cta: "立即估算费用",
        note: "多渠道线路选择，按目的地与预算灵活匹配，提升运输稳定性。",
        sideTitle: "价格透明可查",
        sideCopy: "计费规则公开，费用明细可随时查询，减少不透明收费。",
        sideRows: [
          ["收费明细可见", "清晰展示运费、增值服务费、附加费。"],
          ["小件计费灵活", "部分线路适合散拼和小件需求。"],
          ["仓储周期充足", "便于分批购物，统一合包发货。"]
        ]
      },
      advantages: {
        title: "为什么选择虎鲸国际物流？",
        copy: "专业可信的国际物流服务，为您的包裹提供清晰的流程支持。",
        items: [
          ["bolt", "时效选择灵活", "多渠道线路选择，按目的地与预算灵活匹配。"],
          ["receipt_long", "收费透明", "计费规则公开，费用明细可随时查询，减少不透明收费。"],
          ["local_shipping", "上门取件", "支持指定区域内上门取件，省去跑站点的麻烦。"],
          ["handshake", "代购代付", "协助解决下单与支付问题，适合海外用户购买国内商品。"],
          ["shelves", "阶段性仓储", "提供较长仓储周期，方便全球用户分批采购集中转运。"],
          ["videocam", "打包可视化", "包裹拆箱、合包、加固可按服务选择提供照片或记录。"],
          ["send_time_extension", "及时发货", "包裹完成合包与支付后，仓库会按批次安排渠道发出。"],
          ["security", "服务保障", "针对包裹丢失、异常延误等，按服务保障协议协助处理。"]
        ]
      },
      routes: {
        title: "中国大陆发往全球，多渠道灵活选择",
        copy: "虎鲸国际物流提供空运、海运、铁路专线等多种物流渠道，满足不同货物的寄送需求。",
        coverageLabel: "覆盖地区",
        channelLabel: "推荐渠道",
        etaLabel: "参考时效",
        items: [
          ["public", "北美线路", "美国、加拿大", "空运专线、海运快船", "约 5-12 工作日"],
          ["euro", "欧洲线路", "英国、德国、法国等", "空海铁路、专线运输", "约 7-25 工作日"],
          ["explore", "澳新线路", "澳大利亚、新西兰", "空运专线、海运直航", "约 6-15 工作日"],
          ["location_on", "亚洲线路", "日韩、东南亚、港澳台", "陆运、海运快线、空运", "约 2-7 工作日"]
        ]
      },
      guarantee: {
        title: "多维度服务保障，为寄送过程提供支持",
        copy: "售后服务体系按服务保障条款执行，异常情况结合包裹记录协助处理。",
        status: "以服务保障条款为准",
        cards: [
          ["lock", "隐私保护", "按必要范围处理用户信息与包裹信息，减少信息暴露。", "bg-success/10", "text-success"],
          ["payments", "价格透明", "计费规则公开，费用项目按页面与订单展示为准。", "bg-secondary/10", "text-secondary"],
          ["verified_user", "包裹保障", "针对运输过程中的异常情况按服务保障条款协助处理。", "bg-parcel-orange/10", "text-parcel-orange"],
          ["schedule", "延误处理", "遇到线路波动或异常节点，客服会结合记录协助跟进。", "bg-primary/5", "text-primary"]
        ]
      },
      guide: {
        title: "新手指南",
        moreGuides: "查看更多指南",
        readMore: "查看详情",
        cards: [
          ["如何注册虎鲸国际物流账号？", "三步快速完成会员注册，获取个人专属仓储地址。", "guide"],
          ["如何填写华南仓收件地址？", "在淘宝/京东下单时填写的标准格式与会员标识说明。", "warehouse"]
        ],
        faqTitle: "常见问题",
        faqs: [
          ["包裹到仓后多久可以入库？", "包裹签收后通常会按仓库批次完成入库扫描与信息核对，具体以仓库实际处理记录为准。"],
          ["阶段性仓储服务如何计算？", "仓储周期和超期费用以会员中心及服务协议展示为准，建议集中合包前确认入库时间。"]
        ],
        moreQuestions: "查看更多问题"
      },
      contact: {
        title: "需要帮助？多渠道联系虎鲸客服",
        copy: "无论是订单查询还是特殊寄送需求，我们会通过多渠道为您解答。",
        cards: [
          ["alternate_email", "QQ 客服", "立即联系", "bg-secondary/10", "text-secondary"],
          ["chat", "微信客服", "查看二维码", "bg-success/10", "text-success"],
          ["forum", "WhatsApp", "立即联系", "bg-secondary/10", "text-secondary"],
          ["call", "电话咨询", "查看电话", "bg-parcel-orange/10", "text-parcel-orange"]
        ]
      }
    },
    serviceIntro: {
      badge: "官方服务说明",
      titlePrefix: "一站式 ",
      titleHighlight: "国际集运转运",
      titleSuffix: " 服务",
      subtitle: "为海外华人与留学生提供透明、高效、稳定的物流方案。无论身在何处，国内好物都可以通过清晰流程寄往海外。",
      services: [
        ["inventory_2", "国际集运", "将您在多个平台购买的商品集中存放，一次性打包寄送，帮助减少重复发货成本。", ["网购多件商品", "亲友合单寄送"], "bg-secondary-container/10 text-secondary group-hover:bg-secondary group-hover:text-white"],
        ["rocket_launch", "包裹转运", "包裹到达仓库后可按预设渠道转发至目的地，适合单件包裹和文件类寄送。", ["急需单件包裹", "商务文件寄送"], "bg-tertiary-fixed/30 text-on-tertiary-container group-hover:bg-on-tertiary-container group-hover:text-white"],
        ["architecture", "拆包缩体积", "按需剔除冗余包装、合并零散包裹，通过更合理的摆放减少计费体积。", ["高体积重包裹", "鞋盒/大纸箱减重"], "bg-parcel-orange/10 text-parcel-orange group-hover:bg-parcel-orange group-hover:text-white"],
        ["warehouse", "代收仓储", "提供仓储代收和入库管理，适合分批采购、集中合包与跨境转运。", ["跨季采购存放", "集中备货"], "bg-primary-container/10 text-primary group-hover:bg-primary-container group-hover:text-white"]
      ],
      scenarioLabel: "适用场景",
      addOnsTitle: "增值管家服务",
      addOnsSubtitle: "按不同寄送场景提供可选增值服务",
      addOnsLabel: "增值服务 PLUS +",
      addOns: [
        ["shopping_cart", "代购代付", "代购代买"],
        ["photo_camera", "拍照验货", "高清拆箱验货"],
        ["videocam", "打包过程可视化", "打包记录按需提供"],
        ["door_front", "上门取件", "国内上门取件"],
        ["hub", "多渠道发货", "多渠道按需选择"]
      ],
      audiencesTitle: "面向多类跨境寄送需求",
      audiencesCopy: "我们根据不同人群的常见需求，提供可组合的物流服务。",
      audiences: [
        ["海外华人", "家乡好物寄送到家"],
        ["留学生群体", "书籍行李按需寄送"],
        ["跨境买家", "多平台订单集中管理"],
        ["中小卖家", "按渠道需求发往海外"]
      ],
      flowTitle: "标准化集运流程",
      flowCopy: "简单五步，货物从国内仓库发往目的地",
      flow: [
        ["shopping_bag", "下单购物", "地址填入 Orca 仓库"],
        ["qr_code_scanner", "仓库签收", "入库核对及拍照"],
        ["all_inbox", "申请集运", "多包合一，按需处理"],
        ["payments", "支付费用", "费用明细清晰展示"],
        ["home_pin", "发往目的地", "按节点查询状态"]
      ],
      cta: {
        title: "准备好开始您的全球邮寄旅程了吗？",
        copy: "立即加入 OrcaParcel，查看仓库地址、运费估算、包裹预报与追踪工具。",
        actions: ["立即注册", "运费在线测算", "查看详细流程"]
      }
    },
    guarantee: {
      title: "服务保障机制，让寄送更安心",
      subtitle: "致力于包裹安全、费用透明及服务准则的持续迭代，为您提供稳健的跨境物流体验。我们以多维度保障体系为核心，构建高效、可信的全球物流枢纽。",
      coreTitle: "四大核心保障",
      cards: [
        ["隐私保护", "采用必要的信息保护措施处理个人身份与收寄信息，减少信息在流转过程中的暴露。", "shield"],
        ["价格透明", "公开主要计费项目，从基础运费到增值服务均有说明，减少不透明收费与账单模糊。", "calculator"],
        ["包裹动态保障", "通过多节点轨迹记录展示包裹状态，异常情况按服务保障条款协助处理。", "box"],
        ["延迟处理机制", "针对线路时效波动提供标准化跟进流程，具体处理以线路规则和服务保障条款为准。", "truck"]
      ],
      cardStatus: "以服务保障条款为准",
      flowTitle: "异常处理流程",
      flowSteps: [
        ["提交反馈", "用户通过官网发起售后申请"],
        ["状态核实", "客服及时介入并初步确认包裹状态"],
        ["协同查验", "仓库与线路节点配合核实包裹记录"],
        ["条款解决", "依据核实结果按服务保障条款协助处理"]
      ],
      feeTitle: "费用结构透明说明",
      feeRows: [
        ["国际运输费", "基于包裹计费重与线路基准"],
        ["仓储服务", "超出期限按阶梯标准收费"],
        ["增值服务费", "如拍照、拆箱、加固等自选项"],
        ["特殊附加费", "含偏远地区补差或燃油费率变动"]
      ],
      dataTitle: "数据安全保障",
      dataCards: [
        ["账户信息脱敏", "会员信息、联系方式与包裹信息分级处理。"],
        ["物流轨迹存证", "关键转运节点保留记录，便于后续核查。"],
        ["敏感信息保护", "面单收件人姓名及电话按需进行遮挡处理。"],
        ["合规审计溯源", "服务流程按内部权限和记录机制管理。"]
      ],
      terms: {
        title: "服务保障条款说明",
        copy: "具体保障范围、资料要求、处理周期和责任边界以正式公布内容为准。如需了解细则，可查看服务保障条款或直接联系在线客服。",
        primary: "查看服务保障条款",
        secondary: "联系在线客服"
      },
      faqTitle: "保障机制常见问题",
      faqs: [
        ["包裹遇到极端天气或不可抗力怎么办？", "由于天气、自然灾害等不可抗力导致的延误，我们会启动主动预警机制，并根据线路规则协助跟进。"],
        ["包裹发生破损如何界定责任？", "建议签收时务必先验货。若内件损坏且外包装明显破损，请要求快递员出具破损证明，我们将依据服务保障条款协助核查。"],
        ["运费在下单后会有波动吗？", "订单锁定后的基础运费通常不随市场波动，但在打包称重后，若实际体积或重量与申报不符，将按实计费。"],
        ["如果我对包裹的处理不满意，该找谁？", "您可以直接在官网联系客服反馈，客服会结合运单记录与仓库信息进行二次核查。"]
      ],
      questionPrefix: "Q：",
      cta: {
        title: "遇到包裹问题需要协助？",
        copy: "如遇包裹问题，请提交运单信息，我们会结合服务记录与线路规则协助跟进。",
        actions: ["联系服务专家", "查询物流状态"]
      }
    },
    process: {
      title: "7 步完成国际集运，流程清晰更省心",
      subtitle: "从注册会员到包裹签收，每一步都有明确指引，帮助您更清晰地完成跨境转运。数字化流程让包裹状态、费用与操作节点更易管理。",
      timeline: [
        ["person_add", "注册账号", true],
        ["location_on", "获取地址", true],
        ["shopping_cart", "电商下单", true],
        ["description", "提交预报", false],
        ["inventory_2", "入库合箱", false],
        ["payments", "支付运费", false],
        ["local_shipping", "国际发运", false]
      ],
      stepAddress: {
        badge: "STEP 01 & 02",
        title: "注册会员 & 获取地址",
        copy: "注册成为会员后，您将获得专属会员 ID 和中国大陆集运仓地址。该地址可用于国内电商平台购物时填写收货信息。",
        checks: ["专属会员 ID 用于识别包裹归属", "仓储周期与服务规则以会员中心和服务协议展示为准"],
        sampleTitle: "我的集运地址",
        copyLabel: "复制地址",
        rows: [
          ["收件人：", "虎鲸仓 (ID: ORCA_88924)"],
          ["电话：", "138-0013-8000"],
          ["详细地址：", "广东省深圳市宝安区福永街道 OrcaParcel 转运仓库"]
        ]
      },
      stepPrealert: {
        badge: "STEP 03",
        title: "包裹预报",
        copy: "当您在电商平台完成下单并获得快递单号后，请及时在系统中提交预报。预报有助于仓库识别您的包裹，并提升入库匹配效率。",
        sampleTitle: "包裹预报示例",
        rows: [
          ["国内快递公司", "顺丰速运"],
          ["快递单号", "SF1234567890"],
          ["物品名称", "衣服、鞋子"],
          ["数量", "2"],
          ["预计到达", "待填写"],
          ["物品类目", "普通货物"]
        ]
      },
      valueServices: {
        badge: "STEP 04",
        title: "增值服务，随心定制",
        copy: "入库后的包裹可按需选择多种处理方式，让长途运输更清晰、更可控。",
        items: [
          ["move_to_inbox", "拆箱合包", "去除多余包装，减少包裹体积与重量"],
          ["photo_camera", "拍照验货", "多角度拍摄实物图，核对商品信息"],
          ["shield", "加固包装", "使用气泡膜、护角纸等加强保护"],
          ["content_cut", "精简包装", "按需去除无用广告或多余包装"],
          ["local_post_office", "单独发货", "敏感品或大件物品可按规则单独发运"]
        ]
      },
      payment: {
        badge: "STEP 05 & 06",
        title: "费用确认与支付",
        copy: "系统根据入库后的实际重量、体积重量、目的地和线路规则展示费用明细。支付完成后，包裹将进入发货处理流程。",
        cardTitle: "支付成功",
        rows: [
          ["订单编号", "ORD-20231024-001"],
          ["基础运费（示例）", "¥ 185.00"],
          ["仓储费用", "以会员中心展示为准"],
          ["实付总计", "¥ 185.00"]
        ]
      },
      tracking: {
        badge: "STEP 07",
        title: "国际发运 & 轨迹查询",
        copy: "发货后系统会展示国际物流单号和节点信息，您可以按物流状态查看包裹流转进度。",
        events: [
          ["已从中国集运中心发出", "节点时间以物流记录为准", true],
          ["抵达目的地海关，等待清关", "参考节点，实际以承运商记录为准", false],
          ["目的地派送中", "Pending...", false]
        ]
      },
      statusTitle: "包裹状态说明",
      statusGlossary: [
        ["待入库", "包裹已在路上，但仓库尚未签收录入。", "text-secondary"],
        ["已匹配", "仓库已收到包裹，并成功与预报单匹配。", "text-secondary"],
        ["合箱中", "多个包裹正根据您的指令合并打包。", "text-secondary"],
        ["已发货", "包裹已离开中国仓库，发往目的地国家。", "text-secondary"],
        ["异常处理", "包裹涉及禁运品、单号错误或其他问题，需要联系客服确认。", "text-error"]
      ],
      faqTitle: "集运流程常见问题",
      faqs: [
        ["仓储周期如何查看？", "仓储周期和费用规则以会员中心及服务协议展示为准，建议在发货前确认入库时间和可用仓储政策。"],
        ["支持哪些支付方式？", "第一阶段官网仅展示流程，真实支付方式以后续会员中心和后台接口接入为准。"],
        ["哪些物品是禁止运送的？", "易燃易爆品、违禁药品、枪支弹药等物品严禁寄送。液体、粉末、食品、带电池等敏感物品，请在下单前咨询客服确认可选渠道。"],
        ["包裹发生异常怎么办？", "请联系在线客服并提供会员 ID、国内快递单号和订单信息，客服会结合仓库记录与线路规则协助核查。"]
      ],
      cta: {
        title: "现在开始您的第一次集运",
        copy: "只需注册一个账号，即可查看仓库地址、提交包裹预报并按流程管理跨境包裹。",
        actions: ["立即免费注册", "咨询在线客服"]
      }
    },
    routes: {
      hero: {
        title: "路线查询",
        copy: "智能匹配多种运输方案。根据您的目的地及货物种类，多维度筛选高效、经济、合规的海陆空物流线路。",
        tags: [
          ["check_circle", "实时参考时效"],
          ["shield", "合规清关参考"]
        ]
      },
      filters: {
        destination: ["目的地地区", "location_on", ["北美 (美国、加拿大)", "欧洲 (英、法、德等)", "澳新 (澳大利亚、新西兰)", "亚洲 & 港澳台"]],
        goods: ["货物种类", "category", ["普货 (衣物、日化等)", "带电产品 (3C数码)", "液体/化妆品", "食品/零食", "家具/大件", "搬家行李"]],
        eta: ["参考时效", "schedule", ["较快线路 (2-7天)", "经济型 (15-30天)", "不限时效"]],
        button: "查询线路",
        popularLabel: "常用目的地:",
        popular: ["美国", "英国", "澳大利亚", "加拿大", "德国", "香港"]
      },
      regionsTitle: "区域主力线路",
      metricLabels: {
        channel: "推荐渠道",
        eta: "参考时效",
        suitable: "适合承运"
      },
      actions: ["查看运费", "提交预报"],
      regions: [
        {
          icon: "flight_takeoff",
          bgIcon: "public",
          title: "北美地区 (美国、加拿大)",
          copy: "覆盖主要城市，提供多种线路选择",
          channel: "空运快线 / 海运美森专线",
          eta: "7 - 35 天 (参考时效)",
          tags: ["普货", "数码产品", "特货"]
        },
        {
          icon: "directions_boat",
          bgIcon: "train",
          title: "欧洲全境 (英国、德国、法国等)",
          copy: "海陆空铁全方案组合",
          channel: "空运 / 铁路 / 卡航专线",
          eta: "8 - 45 天 (参考时效)",
          tags: ["服饰鞋帽", "家居大件", "食品专线"]
        },
        {
          icon: "potted_plant",
          bgIcon: "anchor",
          title: "澳新专区 (澳大利亚、新西兰)",
          copy: "空运与海运线路组合",
          channel: "空运快线 / 澳洲海运",
          eta: "7 - 40 天 (参考时效)",
          tags: ["生活用品", "化妆品", "普货"]
        },
        {
          icon: "bolt",
          bgIcon: "local_shipping",
          title: "亚洲 & 港澳台地区",
          copy: "多频次发货，按区域选择渠道",
          channel: "空运快线 / 陆运专线",
          eta: "2 - 15 天 (参考时效)",
          tags: ["普货", "敏感货", "样品件"]
        }
      ],
      channelsTitle: "运输渠道解析",
      channelsCopy: "针对不同包裹特征，我们提供多元化的运输方式，平衡速度与成本。",
      channels: [
        ["flight", "空运快线", "时效较快，适合轻量及较急包裹。"],
        ["sailing", "经济海运", "成本较低，适合大件及不限时包裹。"],
        ["savings", "特惠渠道", "兼顾价格与时效，适合普货集运。"],
        ["rocket_launch", "国际快递", "DHL/FedEx 等商业快递渠道。"],
        ["inventory_2", "敏感专线", "针对食品/化妆品/液体的规则线路。"],
        ["subway", "卡铁专线", "陆运枢纽，适合欧亚大陆运输需求。"]
      ],
      notesTitle: "线路查询注意事项",
      notes: [
        "所有时效均为参考时效，实际受海关查验、天气、排仓及目的地节假日影响可能有所浮动。",
        "敏感货物（液粉、食品、药品、电子产品等）应选择匹配渠道，以免发生退货或扣押。",
        "各国海关政策不同，由于用户申报不实导致的关税或查验费用由发货人承担。",
        "部分偏远地区或大件超材货物可能会产生额外费用，建议发货前与客服确认。",
        "海运等经济渠道存在较长预估周期，请合理安排发货计划。",
        "保障处理遵循《服务协议》和服务保障条款，高价值货物建议按需选择运输保障服务。"
      ],
      cta: {
        title: "不确定选哪条线路?",
        copy: "可先输入包裹尺寸与目的地，查看不同线路的参考报价与费用构成。",
        actions: ["运费估算", "联系客服"]
      }
    },
    help: {
      hero: {
        title: "帮助中心",
        copy: "查找集运流程、费用说明、包裹入库、发货渠道、服务保障等常见问题，快速了解虎鲸国际物流的使用方式。",
        placeholder: "搜索问题，例如：如何填写仓库地址？",
        searchButton: "搜索",
        hotLabel: "热门搜索：",
        hotSearchAria: "热门搜索标签",
        hotTags: ["仓库地址", "包裹预报", "运费估算", "拆箱合包", "路线查询", "代购代付", "禁运品", "服务保障"]
      },
      toolsTitle: "常用工具",
      tools: [
        ["calculate", "运费估算", "输入目的地、重量与体积信息，查看参考运费和费用构成。", "去估算", "tools/shipping-calculator"],
        ["package_2", "包裹预报", "提交国内快递单号，帮助仓库识别并处理包裹。", "去预报", "tools/parcel-prealert"],
        ["track_changes", "包裹追踪", "输入单号查询包裹入库、打包、发货和运输进度。", "去查询", "tools/tracking"],
        ["map", "路线查询", "查看不同国家和地区可用线路、参考时效和适合货物类型。", "查路线", "tools/routes"]
      ],
      categoriesTitle: "按问题类型查找",
      categories: [
        ["person_add", "新手指南", "了解注册、获取仓库地址、购物填写地址和首次集运流程。"],
        ["payments", "费用说明", "了解运费构成、计费重量、体积重、增值服务费用。"],
        ["warehouse", "仓库入库", "了解包裹到仓、扫描入库、会员标识和异常处理。"],
        ["mark_as_unread", "包裹预报", "了解如何提交快递单号、商品信息和合箱需求。"],
        ["deployed_code", "拆箱合包", "了解拆箱、合包、精简包装、加固和体积优化。"],
        ["conversion_path", "线路选择", "了解空运、海运、敏感货专线等渠道区别。"],
        ["add_circle", "增值服务", "了解拍照验货、打包可视化、上门取件等服务。"],
        ["shopping_basket", "代购代付", "了解代购代付流程、费用规则和注意事项。"],
        ["block", "禁运品说明", "了解禁运品、限制品、敏感货和不同目的地规则。"],
        ["verified_user", "服务保障", "了解包裹保障、延误处理、异常件反馈和服务保障条款。"],
        ["account_circle", "账户与支付", "了解注册登录、密码找回、运费支付和信息管理。"]
      ],
      articlesTitle: "精选指南",
      articlesMore: "查看更多指南",
      readFull: "阅读全文",
      articles: [
        ["新手指南", "如何正确填写虎鲸国际物流仓库地址？", "了解收件人、电话、详细地址和会员标识的填写方式，减少入库识别问题。", "/assets/images/warehouse-hub.png"],
        ["包裹预报", "包裹预报填写指南", "提交国内快递单号和商品信息，帮助仓库匹配包裹。", "/assets/images/support-center.png"],
        ["线路选择", "空运、海运、经济线有什么区别？", "根据预算、时效和货物类型选择更适合的发货渠道。", "/assets/images/cargo-plane.png"],
        ["拆箱合包", "拆箱合包适合哪些包裹？", "多个包裹合并发货时，可通过合理合箱减少体积重量。", null],
        ["增值服务", "代购代付服务说明", "了解代购代付流程、费用规则、服务边界和注意事项。", null],
        ["禁运品说明", "禁运品和敏感货寄送注意事项", "不同国家和线路规则不同，寄送前建议确认商品是否可寄。", null]
      ],
      firstUse: {
        title: "第一次使用虎鲸国际物流？",
        copy: "按照以下步骤开始您的第一次国际集运。",
        steps: [
          ["01", "注册账号", "注册后获取专属仓库地址和会员标识。", "立即注册", "register", true],
          ["02", "查看仓库地址", "复制华南仓收件信息，用于国内电商下单。", "查看仓库地址", "warehouse", false],
          ["03", "提交包裹预报", "填写国内快递单号和包裹信息，便于仓库识别。", "提交预报", "tools/parcel-prealert", false],
          ["04", "查询运费并发货", "根据目的地、重量和渠道查看参考费用并发货。", "运费估算", "tools/shipping-calculator", false]
        ]
      },
      serviceTerms: {
        title: "服务条款",
        links: [
          ["description", "服务协议", "legal/service-agreement"],
          ["privacy_tip", "隐私政策", "legal/privacy-policy"],
          ["block", "禁运品须知", "legal/restricted-items"],
          ["verified_user", "服务保障条款", "legal/service-guarantee"]
        ]
      },
      cta: {
        title: "没有找到答案？",
        copy: "可通过微信、WhatsApp、Telegram、Line、QQ、电话、邮箱等渠道联系虎鲸客服，我们将协助您处理集运、包裹、线路和售后相关问题。",
        actions: ["联系客服", "查看常用工具"]
      }
    },
    calculator: {
      title: "运费估算",
      subtitle: "输入目的地、发货渠道、重量与体积信息，快速获取参考运费和费用构成，实际费用以仓库称重和平台展示为准。",
      destinations: [
        ["美国 (USA)", 1.08],
        ["英国 (UK)", 1],
        ["加拿大 (Canada)", 1.12],
        ["澳大利亚 (Australia)", 1.05],
        ["德国 (Germany)", 1.06]
      ],
      channels: [
        { value: "空运 (Air)", rate: 56, eta: "预计 5-7 工作日", route: "国际专线空运" },
        { value: "海运 (Sea)", rate: 22, eta: "预计 18-35 工作日", route: "海运集运线路" },
        { value: "经济 (Economic)", rate: 34, eta: "预计 8-15 工作日", route: "经济专线" },
        { value: "快递 (Express)", rate: 72, eta: "预计 5-7 工作日", route: "国际专线空运" },
        { value: "敏感货 (Sensitive)", rate: 68, eta: "预计 5-7 工作日", route: "国际专线空运" }
      ],
      goodsTypes: [
        ["inventory_2", "普货", 0],
        ["battery_charging_full", "带电", 18],
        ["face_retouching_natural", "化妆品", 18],
        ["restaurant", "食品", 18],
        ["fullscreen", "大件", 35]
      ],
      services: [
        { name: "打包加固", copy: "专业气泡膜包裹，降低运输挤压风险", fee: 18 },
        { name: "拍照核验", copy: "高清货物实拍，确认商品信息", fee: 12 },
        { name: "去除鞋盒/外包装", copy: "减轻体积重，节省运费支出", fee: 8 },
        { name: "运输保障", copy: "异常情况按服务保障条款协助处理", fee: 25 }
      ],
      defaults: {
        destination: "",
        channel: "空运 (Air)",
        goodsType: "普货",
        selectedServices: ["打包加固", "拍照核验"]
      },
      form: {
        destinationLabel: "目的地",
        destinationPlaceholder: "选择国家/地区",
        channelLabel: "发货渠道",
        packageTitle: "包裹参数",
        numberFields: [
          ["重量 (kg)", "0.00"],
          ["长度 (cm)", "长"],
          ["宽度 (cm)", "宽"],
          ["高度 (cm)", "高"]
        ],
        goodsTypeLabel: "货物类型",
        servicesLabel: "增值服务",
        submit: "立即估算"
      },
      result: {
        title: "参考运费",
        recommendedRoute: "推荐线路",
        chargeableWeight: "计费重量",
        costTitle: "费用构成",
        rows: {
          base: "基本运费",
          storage: "仓储服务",
          services: "增值服务费用",
          surcharge: "附加费用"
        },
        notice: "实际运费将根据包裹入库后的实际重量、体积以及目的地线路规则计算。",
        visualTitle: "全球联运，灵活选择",
        visualCopy: "按物流节点查询包裹状态"
      }
    },
    prealert: {
      title: "包裹预报",
      subtitle: "提交国内快递单号和包裹信息，帮助仓库快速识别包裹，提高入库处理效率。",
      categories: ["普通货物", "敏感货", "液体/膏体", "带电产品"],
      couriers: ["请选择快递公司", "顺丰速运", "中通快递", "圆通速递", "申通快递", "韵达快递", "其他"],
      addOns: [
        { icon: "photo_camera", name: "包裹拍照", price: "￥5.00/次", fee: 5 },
        { icon: "inventory_2", name: "合箱打包", price: "免费", fee: 0 },
        { icon: "view_in_ar", name: "气泡加固", price: "￥10.00起", fee: 10 }
      ],
      defaultAddOns: ["合箱打包"],
      steps: ["第 1 步：填写信息", "第 2 步：增值服务", "第 3 步：提交完成"],
      coreTitle: "包裹核心信息",
      fields: {
        courier: "国内快递公司",
        trackingNo: "快递单号",
        trackingPlaceholder: "请输入快递追踪单号",
        itemName: "物品名称",
        itemPlaceholder: "如：衣服、电子产品",
        quantity: "数量",
        quantityPlaceholder: "1",
        arrival: "预估到达",
        category: "物品类目"
      },
      addOnsTitle: "增值服务 (可选)",
      noteLabel: "备注说明",
      notePlaceholder: "如果您对该包裹有特殊要求（如拆鞋盒、去广告等），请在此说明...",
      helper: {
        title: "入库小助手",
        items: [
          ["verified", "准确填报包裹信息，有助于提升仓库识别效率。"],
          ["error", "禁止运输易燃易爆、违禁药品等非法物品。"],
          ["support_agent", "如不清楚物品类目，请联系在线客服咨询。"]
        ]
      },
      summary: {
        packageCountLabel: "包裹数量",
        packageCountValue: "1 件",
        serviceFeeLabel: "增值服务费用",
        submit: "提交预报",
        agreementPrefix: "点击提交即表示您同意",
        serviceAgreement: "《服务协议》",
        submitted: "预报已模拟提交，真实接口待接入。",
        visualLabel: "智能仓储 · 全程追踪"
      }
    },
    tracking: {
      initialNo: "ORCA-2026-X912",
      fallbackNo: "ORCA-2026-X912",
      title: "包裹追踪",
      subtitle: "支持通过国内快递单号、平台包裹号或国际运单号查询包裹状态，了解最新物流进度。",
      searchPlaceholder: "输入您的运单号 (例如: ORCA888999123)",
      searchButton: "立即查询",
      commonSearch: "常用查询：顺丰速运、极兔快递、Amazon、eBay 国际物流",
      statusBadge: "在途",
      trackingNoLabel: "运单号:",
      estimatedDeliveryLabel: "预计送达",
      estimatedDeliveryValue: "以物流节点更新为准",
      steps: [
        ["pending_actions", "待处理", "Pending", true],
        ["warehouse", "已入库", "In Warehouse", true],
        ["notification_important", "预报中", "Pre-alerted", true],
        ["inventory_2", "已合箱", "Consolidated", true],
        ["payments", "待付款", "Payment Pending", true],
        ["sailing", "已发货", "Shipped", true],
        ["local_shipping", "在途中", "In Transit", "active"],
        ["verified_user", "清关中", "Customs", false],
        ["delivery_dining", "派送中", "Delivering", false],
        ["check_circle", "已签收", "Signed", false],
        ["report", "异常", "Exception", false]
      ],
      overview: {
        title: "包裹概览",
        rows: [
          ["当前位置", "中国，广州转运中心", false],
          ["包裹重量", "4.25 kg", false],
          ["运输渠道", "Orca 海运专线", true],
          ["申报价值", "$152.00 USD", false]
        ]
      },
      help: {
        title: "需要帮助？",
        copy: "联系在线客服协助查询",
        action: "立即咨询"
      },
      detailTitle: "详细物流轨迹",
      exportLabel: "导出明细",
      logs: [
        ["示例 14:30", "2026-06-25", "【广州市】包裹已离开广州转运中心，正在发往下一站", "节点记录：转运中心已更新物流状态"],
        ["示例 09:15", "2026-06-24", "【广州市】包裹已到达广州集货仓，正在进行安检扫描", "安检状态：以仓库记录为准"],
        ["示例 18:00", "2026-06-23", "【深圳市】国内快递揽收成功", "发货人已下单，包裹准备中"]
      ],
      map: {
        positionLabel: "示例位置: 华南转运节点",
        destinationTitle: "目的地信息",
        destination: "Unit 4B, Industrial Park, West Coast, USA"
      },
      notifications: {
        title: "追踪通知",
        toggles: [
          ["微信状态推送", true],
          ["邮件进度报告", false]
        ]
      }
    },
    contact: {
      badge: "Customer Support Center",
      title: "联系我们",
      subtitle: "无论是新手集运、包裹入库、代购代付、打包发货、物流追踪还是售后问题，均可通过多种客服渠道联系我们。",
      contacts: [
        ["chat_bubble", "QQ客服", "在线沟通，适用于文件传输与即时咨询。", "立即联系", "arrow_forward", "text-secondary", true, "#"],
        ["qr_code_2", "微信客服", "添加客服顾问，便于沟通包裹入库、预报与发货问题。", "查看二维码", "visibility", "text-success", false, "#"],
        ["public", "WhatsApp", "国际通用沟通渠道，适合海外用户进行集运咨询。", "立即联系", "open_in_new", "text-secondary", true, "#"],
        ["send", "Telegram", "多端同步，适合接收客服沟通与服务通知。", "立即联系", "near_me", "text-on-tertiary-container", true, "#"],
        ["forum", "Line", "适合亚洲地区用户咨询线路、预报和发货问题。", "立即联系", "add_comment", "text-success", true, "#"],
        ["call", "电话咨询", "服务热线适合复杂问题沟通，具体服务时间以页面公示为准。", "拨打热线", "phone_in_talk", "text-parcel-orange", true, "tel:4001886888"],
        ["hub", "官方公众号", "获取物流动态、服务说明与集运相关提示。", "查看二维码", "qr_code_scanner", "text-primary", false, "#"],
        ["mail", "企业邮箱", "用于售后、商务合作、正式投诉与建议。", "发送邮件", "alternate_email", "text-text-secondary", true, "mailto:support@orcaparcel.com"]
      ],
      visual: {
        status: "总部服务中心",
        copy: "物流咨询与服务协调"
      },
      reasonsTitle: "为什么联系我们？",
      reasonsCopy: "我们提供基础运单查询、货品规则咨询、线路选择建议和售后协助，帮助您减少跨境寄送中的信息不确定性。",
      reasons: [
        ["timer", "工单跟进", "客服会按问题类型进行记录与跟进"],
        ["language", "多语种支持", "中文、英文等沟通支持"],
        ["verified", "售后协助", "结合服务保障条款和运单记录协助处理"],
        ["package_2", "代购协助", "协助处理常见平台下单问题"]
      ]
    },
    auth: {
      register: {
        visualBrand: "虎鲸国际",
        visualTitleLines: ["链接全球，", "让跨境集运更简单。"],
        visualCopy: "虎鲸国际为您提供仓储代收、包裹预报、拆箱合包与国际转运相关服务，每一个包裹都可以按流程清晰管理。",
        features: [
          ["inventory_2", "阶段性仓储", "支持包裹集中入库与统一管理"],
          ["photo_camera", "拍照验货", "可按需提供入库拍照服务"],
          ["package_2", "精细合并拆包", "去除冗余包装，合理合并发货"],
          ["visibility", "流程可视化", "按节点查看包裹处理状态"]
        ],
        formTitle: "注册虎鲸国际物流账号",
        formCopy: "注册后即可获得专属仓库地址和会员标识，开始国际集运与包裹转运。",
        fields: {
          account: ["电子邮箱", "请输入您的邮箱"],
          code: ["验证码", "请输入6位验证码", "获取验证码"],
          password: ["设置密码", "8-20位字符，包含字母与数字"],
          confirmPassword: ["确认密码", "请再次输入您的密码"],
          invite: ["邀请码 (可选)", "如有邀请码可在此填写"]
        },
        agreementPrefix: "我已阅读并同意",
        agreementLinks: [
          ["《服务协议》", "legal/service-agreement"],
          ["《隐私政策》", "legal/privacy-policy"],
          ["《禁运品须知》", "legal/restricted-items"]
        ],
        agreementSeparator: "、",
        agreementAnd: " 及 ",
        submit: "立即注册",
        submitted: "注册成功后将进入用户中心。",
        loginPrompt: "已经有账号？",
        loginLink: "立即登录"
      },
      login: {
        visualTitleLines: ["连接全球，", "驱动未来的物流引擎"],
        visualCopy: "从包裹跟踪到仓储中转，一站式管理。通过可视化流程，为您的跨境寄送提供清晰、可追踪的集运转运方案。",
        pill: "用于包裹预报、集运申请与物流跟踪的统一入口。",
        reminderTitle: "服务提醒",
        reminderStage: "第一阶段前端演示",
        reminderCopy: "登录、注册、支付与后台数据接口暂未接入；当前页面用于展示后续会员中心入口与模拟交互。",
        formTitle: "欢迎回来",
        formCopy: "请输入您的登录信息以继续",
        account: ["电子邮箱", "请输入您的邮箱"],
        passwordLabel: "密码",
        forgotPassword: "忘记密码？",
        unavailableNotice: "第三方登录后续开放",
        passwordPlaceholder: "请输入密码",
        remember: "记住我",
        submit: "立即登录",
        submitted: "登录成功后将进入用户中心。",
        divider: "其他登录方式",
        google: "Google",
        wechat: "微信登录",
        registerPrompt: "还没有账号？",
        registerLink: "立即注册新账号"
      }
    },
    guide: {
      hero: {
        badge: "新手专属快速通道",
        title: "新手指南",
        copy: "第一次使用虎鲸国际物流 OrcaParcel？请按注册会员、填写仓库地址、提交包裹预报、选择服务与支付发货的流程操作，帮助包裹更顺畅地完成入库与国际转运。",
        primaryCta: "立即注册",
        secondaryCta: "查看仓库地址",
        imageAlt: "OrcaParcel 新手集运流程视觉"
      },
      stepsTitle: "4 步开始使用 OrcaParcel",
      stepsSubtitle: "简单清晰，开启您的国际集运流程",
      steps: [
        ["person_add", "1. 注册会员", "获取专属会员 ID 与国内转运仓库地址。", "register"],
        ["shopping_cart", "2. 下单购物", "在国内电商平台填写虎鲸仓库收件信息。", "warehouse"],
        ["notifications_active", "3. 预报包裹", "包裹发出后，在系统提交国内快递单号。", "tools/parcel-prealert"],
        ["local_shipping", "4. 支付发货", "包裹入库后选择线路、支付费用并等待发出。", "tools/tracking"]
      ],
      warehouse: {
        title: "仓库地址填写指南",
        copy: "为了帮助仓库准确识别包裹，请在收货人或详细地址中填写您的专属会员 ID。",
        highlight: "专属会员 ID",
        rows: [
          ["收货人 (Recipient)", "虎鲸仓 - [您的会员ID]"],
          ["手机号码 (Phone)", "请以会员中心展示的仓库电话为准"],
          ["所在地区 (Region)", "广东省 深圳市 宝安区 福永街道"],
          ["详细地址 (Address)", "仓库详细地址 + [您的会员ID]"],
          ["邮政编码 (Zip)", "518103"]
        ],
        tipTitle: "核心提示",
        tipCopy: "会员 ID 是识别包裹归属的关键。如未填写或填写不完整，可能需要人工申领，影响入库处理。"
      },
      prealert: {
        title: "包裹预报指南",
        subtitle: "为什么要预报？",
        copy: "包裹预报能让系统在包裹到达仓库时更快匹配您的账户。建议在国内平台发货后及时提交快递单号和商品信息。",
        checklist: ["国内快递单号 (Tracking Number)", "物品名称与数量 (Content & Qty)", "物品申报价值 (Declared Value)"],
        statusTitle: "状态标识说明",
        statuses: [
          ["已提交 (Submitted)", "bg-secondary"],
          ["已匹配 (Matched)", "bg-success"],
          ["异常件 (Abnormal)", "bg-warning"],
          ["需确认 (Review)", "bg-error"]
        ]
      },
      operationsTitle: "入库后的操作选择",
      operations: [
        ["inventory_2", "单件发货", "单个包裹直接转运，适合较急或不需合包的包裹。"],
        ["dynamic_feed", "批量合箱", "多个包裹合并为一箱，大件或轻泡货需结合体积重判断。"],
        ["verified", "增值验货", "按需提供拍照、加固包装、减少外包装等服务。"],
        ["layers", "线路选择", "可按预算、货物属性和目的地选择适合线路。"]
      ],
      channels: {
        title: "运输渠道解析",
        copy: "不同包裹可选择不同渠道。对应可用渠道、参考时效与费用以实际下单页面和线路规则为准。",
        routes: [
          ["1", "较快空运 (Air)", "小件、急需物品，可按目的地查看参考时效。"],
          ["2", "经济海运 (Sea)", "适合大体积、重货或预算敏感包裹。"],
          ["3", "敏感专线 (Special)", "部分特殊品类需按线路规则确认可寄性。"],
          ["4", "铁路/陆运 (Rail/Truck)", "部分目的地可选，适合稳定批量运输。"]
        ],
        actions: [
          ["智能选择", "tools/routes"],
          ["运费计算", "tools/shipping-calculator"],
          ["咨询客服", "contact"]
        ]
      },
      infoCards: [
        {
          icon: "payments",
          title: "支付说明",
          copy: "运费通常由基础运费、增值服务费、附加费用等构成，实际费用以称重计费和页面展示为准。",
          notice: "费用规则提示：不同线路、目的地、货物属性和体积重量会影响最终费用。"
        },
        {
          icon: "conversion_path",
          title: "物流全程追踪",
          copy: "包裹发出后可按节点查看入库、打包、出库、运输、清关和派送等状态。",
          steps: ["预报", "入库", "出库", "运输", "派送"]
        }
      ],
      tipsTitle: "给新手的 7 条核心贴士",
      tips: [
        ["01.", "准确会员信息", "收货人或地址中填写会员 ID，方便仓库识别。"],
        ["02.", "保留单号", "国内平台发货后保存快递单号，用于包裹预报。"],
        ["03.", "合理合箱", "多件商品可按需合箱，但需注意体积重和禁运规则。"],
        ["04.", "分类申报", "如实填写品名、数量和申报价值，便于后续运输处理。"],
        ["05.", "安全包装", "易碎或贵重物品可选择加固、拍照等增值服务。"],
        ["06.", "关注状态", "定期查看包裹状态，异常信息请及时联系在线客服。"],
        ["07.", "确认规则", "寄送前查看禁运品须知和目的地线路说明。"]
      ],
      cta: {
        title: "准备开始第一次集运？",
        copy: "不论是淘宝购物还是亲友寄件，虎鲸国际物流都可以帮助您按流程完成包裹代收、合包与发货。",
        actions: ["注册会员", "查看操作指南", "联系客服"]
      }
    },
    faq: {
      hero: {
        title: "我们能为您提供什么帮助？",
        placeholder: "搜索常见问题...",
        empty: "未找到相关结果"
      },
      categories: [
        {
          id: "account",
          title: "账号安全",
          icon: "shield",
          questions: [
            ["如何重置我的账户密码？", "账户找回功能将在账户系统接入后开放。如需协助，可先联系虎鲸国际物流客服。"],
            ["为什么建议填写真实联系方式？", "联系方式用于包裹异常、入库确认、费用通知和客服协助，请保持信息可联系。"],
            ["注册后如何获取会员 ID？", "注册完成后，会员中心会展示您的专属会员 ID 和可用仓库地址。"]
          ]
        },
        {
          id: "warehouse",
          title: "仓库地址",
          icon: "warehouse",
          questions: [
            ["仓库地址应该怎么填写？", "请按仓库地址页展示的收货人、电话、详细地址和邮编填写，并在收货人或地址中加入会员 ID。"],
            ["没有填写会员 ID 会怎样？", "仓库可能无法自动识别包裹归属，需要人工核对或申领，处理时间可能延长。"],
            ["可以同时寄多个包裹到仓库吗？", "可以。建议每个国内快递单号都提交包裹预报，方便后续合包与发货。"]
          ]
        },
        {
          id: "prealert",
          title: "包裹预报",
          icon: "notifications_active",
          questions: [
            ["什么时候提交包裹预报？", "国内平台发货并获得快递单号后即可提交预报。"],
            ["预报信息填错怎么办？", "如包裹尚未匹配，可修改或联系客服协助核对。"],
            ["预报后是否一定会立即入库？", "入库时间以仓库签收、扫描和核对记录为准，预报有助于提高识别效率。"]
          ]
        },
        {
          id: "shipping",
          title: "运费估算",
          icon: "calculate",
          questions: [
            ["运费估算结果是最终费用吗？", "估算结果仅供参考，最终费用以包裹入库后的实际重量、体积重量、线路规则和增值服务为准。"],
            ["体积重是什么？", "体积重是根据包裹尺寸换算出的计费重量，部分线路会按实际重和体积重较高者计费。"],
            ["为什么同样重量费用不同？", "目的地、渠道、货物类型、体积和附加服务都会影响费用。"]
          ]
        },
        {
          id: "routes",
          title: "路线查询",
          icon: "map",
          questions: [
            ["如何选择适合的运输线路？", "建议结合目的地、预算、货物属性和参考时效选择，可在路线查询页查看不同线路说明。"],
            ["参考时效是否固定？", "参考时效会受航班、清关、旺季和目的地派送影响，请以实际物流节点为准。"],
            ["敏感货可以寄吗？", "部分货物需要走特定渠道，寄送前请查看禁运品须知并咨询客服确认。"]
          ]
        },
        {
          id: "guarantee",
          title: "服务保障",
          icon: "verified_user",
          questions: [
            ["包裹异常如何处理？", "请提供会员 ID、国内快递单号、订单信息和相关照片，客服会结合仓库记录与线路规则协助跟进。"],
            ["服务保障范围在哪里查看？", "请查看服务保障条款，具体范围、资料要求和处理方式以正式公布内容为准。"],
            ["禁运品被拦截怎么办？", "禁运品或限制物品需按平台、仓库、承运方和目的地规则处理，建议发货前确认可寄性。"]
          ]
        }
      ]
    },
    news: {
      hero: {
        badge: "最新资讯",
        title: "新闻动态",
        copy: "了解虎鲸国际物流平台公告、线路调整、服务升级及全球物流知识，帮助您更清晰地管理跨境包裹。"
      },
      tabs: ["全部", "平台公告", "线路动态", "服务升级", "集运百科", "新手教程", "禁运提醒", "假期安排"],
      searchPlaceholder: "搜索文章内容...",
      featured: {
        tags: ["PLATFORM", "NOTICE"],
        title: "平台公告与线路运行安排说明",
        copy: "这里用于展示平台公告、仓库作业安排、线路调整等重要信息。正式新闻内容将由后台发布并以页面实际展示为准。",
        date: "待发布",
        action: "立即阅读",
        image: "/assets/images/warehouse-hub.png"
      },
      articles: [
        ["新手教程", "如何正确填写虎鲸国际物流仓库地址？", "了解收货人、联系电话、详细地址和会员标识的填写方式，减少入库识别问题。", "待发布"],
        ["集运百科", "空运、海运与经济线路应该如何选择？", "从预算、包裹体积、目的地和货物属性等维度，了解不同运输方式的适用场景。", "待发布"],
        ["禁运提醒", "寄送前请先确认禁运品与限制寄送规则", "发货前建议查看禁运品须知，并结合目的地、线路和承运方规则确认可寄性。", "待发布"],
        ["服务升级", "包裹预报为什么有助于仓库识别？", "提前提交国内快递单号和商品信息，有助于仓库在签收后匹配包裹归属。", "待发布"]
      ],
      readMore: "查看详情",
      preview: {
        kicker: "Article Preview",
        title: "精选内容深度解析",
        tag: "集运百科",
        date: "待发布",
        headline: "跨境包裹物流方式选择说明",
        paragraphs: [
          "在选择国际物流服务时，常见问题是：应该选择空运、海运还是经济线路。不同运输方式会影响参考时效、费用结构和可寄货物范围。",
          "空运通常适合体积较小、需要较快安排的包裹；海运更适合大件或预算敏感包裹。实际可选线路需结合目的地、货物属性和仓库页面展示为准。"
        ],
        quote: "如果不确定包裹是否包含电池、液体、粉末或其他限制物品，建议先咨询客服确认可寄线路。",
        button: "阅读原文"
      },
      subscribe: {
        title: "关注 OrcaParcel 最新动态",
        copy: "订阅功能后续开放。当前可通过帮助中心或客服渠道关注平台公告、线路说明和禁运规则更新。",
        placeholder: "您的电子邮箱地址",
        button: "订阅功能后续开放",
        notes: ["周报更新", "随时退订", "隐私保护"]
      }
    },
    careers: {
      hero: {
        badge: "OrcaParcel 正在全球招募",
        title: "加入我们",
        copy: "与 OrcaParcel 一起，构建下一代智慧跨境集运生态。我们正在寻找热爱技术、崇尚效率，并希望在全球物流领域创造真实价值的伙伴。",
        primaryCta: "查看开放职位",
        secondaryCta: "投递简历",
        imageAlt: "OrcaParcel 招聘视觉"
      },
      missionTitle: "我们正在做的事",
      missions: [
        ["hub", "数字化平台", "重构集运系统的底层架构，实现从包裹录入到全球配送的流程透明化与状态追踪。"],
        ["inventory_2", "仓储自动化", "引入更清晰的仓储作业流程与工具，提升转运中心处理效率。"],
        ["dynamic_feed", "物流协同", "优化多线路、多渠道协同，让跨境包裹在复杂环境中保持更清晰的流转状态。"],
        ["support_agent", "异常治理", "建立异常问题处理机制，主动响应用户痛点，减少跨境寄送中的不确定性。"],
        ["auto_awesome", "产品体验", "通过清晰的设计语言与顺滑交互，让复杂国际寄送流程更易理解。"]
      ],
      valuesTitle: "我们重视的工作方式",
      valuesCopy: "在 OrcaParcel，文化不仅是墙上的口号，更是我们解决每一个问题的准则。",
      values: [
        ["verified_user", "责任心", "每一个包裹背后都是一个期待，我们重视结果负责和持续跟进。"],
        ["forum", "透明沟通", "跨团队高度协同，鼓励真实反馈与直接讨论，减少信息损耗。"],
        ["trending_up", "持续优化", "没有完美的流程，只有不断优化的逻辑。我们重视用工具减少低效重复。"],
        ["balance", "规则共识", "建立清晰、公正的协作标准，让每个人在确定框架下发挥能力。"]
      ],
      stageTitle: "在这里，你可以发挥的舞台",
      stages: [
        ["CORE OPS", "仓储运营", "统筹包裹分拨、打包、出库的每一个环节。", "warehouse"],
        ["headset_mic", "客户服务", "用专业化工具提供有温度的服务。"],
        ["local_shipping", "国际物流", "航线开拓与全球清关渠道维护。"],
        ["campaign", "市场营销", "品牌建设与海内外精准引流。"],
        ["code", "技术 & 设计", "产研驱动，用代码和视觉定义集运新范式。"]
      ],
      jobsTitle: "当前开放职位",
      jobsCopy: "我们在寻找有远见的先行者。",
      jobsUpdated: "最后更新：待填写",
      jobHeaders: ["职位名称", "部门", "地点", "类型", "操作"],
      jobs: [
        ["集运仓储主管", "运营部", "广东·深圳", "全职"],
        ["资深海外客服", "客服中心", "广东·深圳", "全职"],
        ["国际物流专员", "商务部", "广东·深圳", "全职"],
        ["高级前端开发工程师", "技术部", "广东·深圳", "全职"],
        ["内容运营（新媒体）", "市场部", "广东·深圳", "实习 / 全职"]
      ],
      applyLabel: "申请职位",
      application: {
        title: "主动投递",
        copy: "如果你在这里没有看到完全匹配的职位，但相信自己能为 OrcaParcel 带来价值，我们欢迎你主动联系我们。",
        emailLabel: "简历邮箱",
        email: "careers@orcaparcel.com",
        subjectLabel: "标题格式",
        subject: "【主动投递】姓名 - 意向岗位/方向 - 当前所在地",
        attachmentLabel: "附件建议",
        attachment: "建议使用 PDF 格式，如果有作品集或 Github 链接请在正文中标注。",
        cardTitle: "准备好起航了吗？",
        cardCopy: "我们会在收到简历后尽快查看，并联系匹配的候选人。",
        copyButton: "复制投递邮箱",
        copiedButton: "已复制",
        privacy: "OrcaParcel 将按隐私政策处理申请人的个人信息。"
      },
      cta: {
        title: "一起建设更清晰的国际集运体验",
        copy: "我们不仅在处理包裹流转，也在连接跨境生活与信任。加入我们，共同打磨全球物流的新体验。",
        action: "现在就联系我们"
      }
    },
    legal: zhLegalContent,
    about: {
      serviceTags: [
        ["package_2", "国际集运"],
        ["local_shipping", "包裹转运"],
        ["warehouse", "仓储代收"],
        ["inventory_2", "拆箱合包"],
        ["home_work", "上门取件"],
        ["public", "全球派送"]
      ],
      hero: {
        titlePrefix: "关于",
        titleHighlight: "虎鲸国际物流",
        titleSuffix: " OrcaParcel",
        subtitle: "专注国际集运、包裹转运、仓储中转与全球派送服务，为海外华人、留学生及跨境用户提供透明、高效、稳定的一站式跨境寄送解决方案。",
        copy: "虎鲸国际物流从中国大陆仓库代收到国际运输派送，通过数字化流程、精细化仓储操作和多渠道发货能力，让跨境包裹寄送更清晰、更可控、更省心。",
        primaryCta: "立即注册",
        secondaryCta: "查看仓库地址",
        visualKicker: "Digital Marine Logistics",
        visualTitle: "Smart Route A1",
        visualStatus: "Active Navigation",
        visualHeadline: "连接全球包裹流转"
      },
      who: {
        title: "我们是谁",
        copy: "虎鲸国际物流（OrcaParcel）是面向海外华人、留学生、跨境购物用户及跨境卖家的国际集运与包裹转运服务平台。我们围绕中国大陆至全球的跨境寄送需求，提供仓库代收、包裹预报、拆箱合包、拍照验货、加固包装、运费估算、路线选择和国际派送等服务。"
      },
      audiencesTitle: "我们服务谁",
      audiencesSubtitle: "为每一位全球用户提供更清晰的跨境物流体验。",
      audiences: [
        ["groups", "海外华人", "身在海外，也能更方便地购买国内商品，感受熟悉的家乡味道。"],
        ["school", "留学生", "书籍资料、生活必需品按需转运，支持学生预算的寄送选择。"],
        ["shopping_cart", "跨境购物用户", "国内电商平台下单后，代收多个包裹并按需合并寄送。"],
        ["storefront", "跨境电商用户", "为小微跨境卖家提供基础仓储、验货与订单履行支持。"]
      ],
      capabilitiesTitle: "一站式跨境包裹服务能力",
      capabilities: [
        ["warehouse", "仓库代收", "专业仓库团队代收国内各大平台包裹，数字化入库管理。"],
        ["notification_add", "包裹预报", "提前录入国内快递单号，包裹到库后便于识别匹配。"],
        ["inventory", "拆箱合包", "去除冗余外包装，将多个包裹按需合并，帮助减少体积重量。"],
        ["photo_camera", "拍照验货", "包裹到库后可按需提供实物拍照，便于确认商品信息。"],
        ["shield", "加固包装", "针对易碎品或高价值物品提供气泡膜、纸箱等加固方案。"],
        ["rocket_launch", "多渠道发货", "提供空运、海运等多种物流渠道，平衡时效与成本。"]
      ],
      flowTitle: "让跨境寄送流程更清晰",
      flow: [
        ["1", "注册账号", "获取专属仓库地址"],
        ["2", "国内购物", "邮寄至 Orca 仓库"],
        ["3", "提交预报", "填写物流单号"],
        ["4", "选择服务", "合包/加固/选路线"],
        ["5", "确认费用", "打包后称重计费"],
        ["6", "支付发货", "结算运费并出库"],
        ["7", "追踪签收", "全程监控安心收货"]
      ],
      principles: [
        ["visibility", "信息透明", "价格透明、流程透明、轨迹透明，让费用与状态更清晰。", true],
        ["precision_manufacturing", "操作精细", "从入库称重到出库打包，每一个环节都按流程细致处理。", false],
        ["speed", "响应及时", "按流程入库、打包、发货，客服团队按问题类型协助跟进。", false],
        ["handshake", "稳定协同", "深耕物流渠道，在复杂跨境场景下保持服务协同。", false]
      ],
      warehouse: {
        badge: "阶段性仓储服务",
        title: "从华南仓出发，连接全球包裹流转",
        copy: "我们的仓库坐落于中国华南物流枢纽。依托分拣流程与 WMS 仓库管理系统，帮助到库包裹及时处理，为后续全球寄送奠定基础。",
        checks: ["自动化分拣系统", "全天候监控覆盖", "多口岸发货能力", "温控仓储区"],
        hub: "深圳宝安物流分拨中心",
        capacityLabel: "实时运能",
        capacityValue: "High Capacity"
      },
      reasonsTitle: "为什么选择 OrcaParcel",
      reasons: [
        ["analytics", "流程清晰", "从入库到签收，每一个状态节点按流程同步，减少信息不确定性。"],
        ["payments", "计费透明", "基于实际重量、体积重量和线路规则计费，费用结构清晰。"],
        ["published_with_changes", "服务灵活", "支持包裹拆分、订单合并、阶段性暂存，满足多样化集运需求。"],
        ["inventory", "打包精细", "仓库团队按商品属性使用合适包装材料，降低运输挤压风险。"],
        ["support_agent", "客服协助", "客服协助处理清关咨询、异常反馈等跨境寄送问题。"],
        ["hub", "适配多场景", "个人自用、礼品寄送、商业补货等场景均可按需匹配方案。"]
      ],
      vision: {
        title: "让国际集运更简单、更清晰、更安心",
        copy: "我们致力于通过数字化的跨境物流架构，连接海内外华人生活、情感与商机。虎鲸国际物流将持续打磨流程体验，让跨境包裹寄送更清晰、更可控。"
      },
      bottomCta: {
        title: "立即选择虎鲸国际物流！",
        copy: "注册账号后即可获取仓库地址，开启清晰透明的寄送之旅。",
        actions: ["立即注册", "查看仓库地址", "联系客服"],
        contactLabels: [
          ["chat", "微信公众号"],
          ["forum", "WhatsApp"],
          ["alternate_email", "邮件支持"],
          ["smart_display", "操作视频"]
        ]
      }
    },
    warehouse: {
      heroBadge: "官方自营仓",
      title: "华南仓库地址",
      subtitle: "请将包裹寄送至以下地址，入库后我们将为您处理拆箱合包与国际转运。专属会员 ID 是识别您包裹的重要凭证，请务必准确填写。",
      cardTitle: "广东·深圳仓",
      cardSubtitle: "Shenzhen International Logistics Hub",
      copyAllLabel: "一键复制",
      copiedLabel: "已复制",
      copyAllAria: "一键复制仓库收件信息",
      copyFieldAriaPrefix: "复制",
      copyAllText: "收货人：虎鲸仓 ORCA_88924\n联系电话：13800138000\n详细地址：广东省深圳市宝安区福永街道塘尾工业区 OrcaParcel 转运仓库 ORCA_88924\n邮政编码：518103",
      fields: [
        {
          label: "收货人 (Recipient)",
          valuePrefix: "虎鲸仓 / ",
          valueHighlight: "ORCA_88924",
          copy: "虎鲸仓 ORCA_88924",
          emphasis: true,
          warning: "必须包含 ORCA_ 开头的会员 ID，否则无法识别包裹"
        },
        {
          label: "联系电话 (Phone Number)",
          value: "138-0013-8000",
          copy: "13800138000"
        },
        {
          label: "详细地址 (Shipping Address)",
          value: "广东省深圳市宝安区福永街道塘尾工业区 OrcaParcel 转运仓库",
          valueHighlight: "(会员ID: ORCA_88924)",
          copy: "广东省深圳市宝安区福永街道塘尾工业区 OrcaParcel 转运仓库 ORCA_88924",
          multiline: true
        },
        {
          label: "邮政编码 (Zip Code)",
          value: "518103",
          copy: "518103"
        }
      ],
      example: {
        title: "电商平台填写示范",
        platform: "淘宝 / 1688 示范",
        zoom: "查看示意",
        alt: "电商平台地址填写示范",
        tip: "提示：务必将专属会员 ID 填入“收件人”或“详细地址”中。",
        batchTitle: "批量采购注意事项",
        batchCopy: "若在 1688 采购，请尽量与卖家确认包裹数量；如分箱发货，请保存所有国内快递单号。"
      },
      notesTitle: "寄送须知与仓库时间",
      notes: [
        ["schedule", "作业时间", "周一至周六：09:00 - 22:00\n周日：10:00 - 18:00\n节假日另行通知。", "bg-secondary/10", "text-secondary", "hover:border-secondary"],
        ["dangerous", "违禁品说明", "严禁寄送易燃易爆、腐蚀性、毒性及法律法规规定的各类禁寄物品。", "bg-error-container/20", "text-error", "hover:border-error"],
        ["verified_user", "仓储保护", "仓库内采用监控、防潮和分区堆放等措施，降低包裹挤压受潮风险。", "bg-success/10", "text-success", "hover:border-success"]
      ],
      cta: {
        title: "包裹已经寄出了？",
        copy: "请在国内平台发货后，前往 OrcaParcel 系统填写预报单号，帮助仓库识别包裹。",
        actions: ["立即前往包裹预报", "查看运费报价"]
      }
    }
  }
} as const;
